import { render } from "./consume.vue?vue&type=template&id=f7fae356&scoped=true"
import script from "./consume.vue?vue&type=script&lang=js"
export * from "./consume.vue?vue&type=script&lang=js"

import "./consume.vue?vue&type=style&index=0&id=f7fae356&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7fae356"]])

export default __exports__